import React, { useState } from 'react';
import { post } from 'axios';

import Overlay from 'components/Overlay';

import FilledButton from 'components/Buttons/FilledButton';
import UnfilledButton from 'components/Buttons/UnfilledButton';

import { renderToast } from 'components/Informations/Toast/utils';

import endpoints from 'services/endpoints';

const { deleteQuestion } = endpoints;

const RemoveQuestion = ({ data, open, setOpen }) => {
  const { id_questao, id_funcionario: idFuncionario, observer } = data;

  const [toastVisibility, setToastVisibility] = useState(false);
  const [toastInfos, setToastInfos] = useState({
    type: '',
    message: '',
    autoClose: 6000,
  });

  const handleDelete = () => {
    const objectToSend = {
      id_questao,
      id_usr_up: idFuncionario,
    };

    return post(deleteQuestion, objectToSend)
      .then(() => {
        setToastVisibility(true);
        setToastInfos({
          type: 'information',
          message: 'Questão removida',
          autoClose: 6000,
        });
      })
      .then(() => {
        setTimeout(() => {
          observer();
          setOpen(false);
        }, 4000);
      })
      .catch(() => {
        setToastVisibility(true);
        setToastInfos({
          type: 'error',
          message: 'Erro ao remover questão',
          autoClose: 6000,
        });
      });
  };

  return (
    <>
      {toastVisibility &&
        renderToast(
          toastInfos.type,
          toastInfos.message,
          toastInfos.autoClose,
          setToastVisibility
        )}

      <Overlay
        isOpen={open}
        type="warning"
        text={[
          <span>Deletar</span>,
          ' a questão? Você não poderá desfazar esta ação',
        ]}
      >
        <UnfilledButton
          text="Não, cancelar"
          handleClick={() => setOpen(!open)}
        />
        <FilledButton
          text="Sim, deletar"
          buttonClass="warn"
          handleClick={handleDelete}
        />
      </Overlay>
    </>
  );
};

export default RemoveQuestion;
